import { render } from "./Pharmacy.vue?vue&type=template&id=51ba938f&scoped=true&ts=true"
import script from "./Pharmacy.vue?vue&type=script&lang=ts"
export * from "./Pharmacy.vue?vue&type=script&lang=ts"

import "./Pharmacy.vue?vue&type=style&index=0&id=51ba938f&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ba938f"]])

export default __exports__